import { render, staticRenderFns } from "./AttachedImageEditor.vue?vue&type=template&id=3e477fdc&scoped=true&"
import script from "./AttachedImageEditor.vue?vue&type=script&lang=js&"
export * from "./AttachedImageEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e477fdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
